import * as types from './types';

export const changeProducersVersion = () => ({
  type: types.CHANGE_PRODUCERS_VERSION
});
